<template>
  <div class="publicSubmit">
    <app-header></app-header>
    <div class="app-wrapper" :class="classObj">
      <div class="login-container">
        <div class="container clearfix">
          <div class="initBox">
            <div class="initTitle">初始化企业信息</div>
            <div class="initwd">
              <el-form
                :model="enValidateForm"
                @submit.native.prevent
                ref="enValidateForm"
                class="demo-ruleForm"
              >
                <el-form-item
                  label="企业名称"
                  prop="name"
                  :rules="[{ required: true, message: '企业名称不能为空'}]"
                >
                  <el-input v-model="enValidateForm.name" autocomplete="off"></el-input>
                </el-form-item>
                <div class="help-block"></div>
                <el-form-item>
                  <div class="prompt-message" style="margin:0 0 20px 0;">
                    <p>企业用户将获取更多服务支持</p>
                  </div>
                  <div style="margin-top: 10px;">
                    <el-button type="primary" @click="submitForm('enValidateForm')">注册企业</el-button>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnterpiseInit',
  data() {
    return {
      teamData: [],
      username: '',
      enValidateForm: {
        open_market: false,
        name: ''
      }
    };
  },
  created() {},
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      };
    },
    open_market() {
      return this.$store.state.enterprise.current.open_market;
    }
  },
  methods: {
    push(eid) {
      if (this.$route.query.routerName) {
        this.$router.push({
          name: this.$route.query.routerName,
          params: { enterpriseID: eid },
          query: {
            redirect: this.$route.query.redirect,
            join_id: this.$route.query.join_id,
            callback_url: this.$route.query.callback_url || null,
            rbd_version: this.$route.query.rbd_version || null
          }
        });
      } else {
        this.$router.push({
          name: this.open_market ? 'orderManageAll' : 'myorderAll',
          params: {
            enterpriseID: eid,
            orderState: 'all',
            orderManageType: 'merchants'
          }
        });
      }
    },
    submitForm(formName) {
      if (formName == 'userEnterpriseForm') {
        this.$store
          .dispatch('AddEnterprise', {
            name: this.$store.getters.name,
            open_market: false
          })
          .then(en => {
            if (en) {
              this.push(en.enterprise_id);
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.$store
              .dispatch('AddEnterprise', this.enValidateForm)
              .then(en => {
                if (en) {
                  this.push(en.enterprise_id);
                }
              })
              .catch(err => {
                console.log(err);
              });
          }
        });
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
@import "src/styles/header.scss";
@import "src/styles/publicSubmit.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
}

.el-menu-demo {
  border-bottom: none;
  background: #f7f8fa;
  color: rgb(50, 150, 250);
}

.el-menu-demo li {
  float: inherit;
}
</style>

<style rel="stylesheet/scss" lang="scss" >
.el-menu-demo .el-submenu__title {
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/enterprise/init.vue